import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { type Broker } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export function getBrokersQueryKey () {
  return ['brokers', 'brokers']
}

type BrokerData = {
  data: Broker[]
}

export function useGetBrokers () {
  return useQuery<BrokerData, GrapeAPIErrorType>({
    queryKey: getBrokersQueryKey(),
    queryFn: async () => {
      const response = await fetchWithHeaders(
        '/api/web/brokers/brokers'
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    retry: false,
  })
}
